var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useStyles } from "./FileStyles";

var _ref = /*#__PURE__*/_jsx(CloudDownloadIcon, {});

const File = props => {
  const classes = useStyles(props);
  const linkRef = useRef();
  if (typeof props.content === 'string') props.content = JSON.parse(props.content);
  const _props$content = props.content,
        name = _props$content.name,
        extension = _props$content.extension,
        url = _props$content.url;
  return _jsx("div", {
    className: classes.container
  }, void 0, React.createElement("a", {
    ref: linkRef,
    href: url,
    download: true,
    className: classes.icon
  }, _ref), _jsx("div", {
    onClick: () => linkRef.current.click(),
    className: classes.file
  }, void 0, name, !name.endsWith(extension) && ".".concat(extension)));
};

export { File };